/* eslint-disable react-hooks/exhaustive-deps */
import Loading from "components/Loading";
import { useTooltip } from "context/TooltipProvider";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  addInvestigation,
  editInvestigation,
  fetchCrimeReferences,
  fetchCrimeSubCategory,
} from "services/incidentService";
import {
  editReceivingInvestigationFile2,
  fetchPolice,
  fetchProsecutor,
} from "services/prosecutorPoliceService";
import {
  CrimeReference,
  CrimeSubCategory,
  Investigation,
  InvestigationFile,
  InvestigationFileStatus,
  Police,
  Prosecutor,
} from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  isOpen: boolean;
  incident: CrimeReference | undefined;
  file?: InvestigationFile | null;
  action: "Add" | "Edit";
  investigation?: Investigation;
  onClose: (refetch: boolean) => void;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultInvestigation: Investigation = {
  uu_id: 0,
  crime_reference_id: null,
  CR_number: "",
  crime_category_id: null,
  investigation_status: null,
  assigned_prosecutor: "",
  assigned_police: "",
  assigned_team: "",
  start_date: null,
  description: "",
  investigation_result_naration: "",
  Incident_Registration_number: "",
  asset_reference: "",
};
const InvestigationForm: FC<Props> = ({
  isOpen,
  incident,
  file,
  action,
  investigation,
  onClose,
  setRefetch,
}) => {
  const navigate = useNavigate();
  const { showTooltip } = useTooltip();
  const [incidents, setIncidents] = useState<CrimeReference[]>([]);
  const [crimeSubCategory, setCrimeSubCategory] = useState<CrimeSubCategory[]>(
    [],
  );
  const [prosecutors, setProsecutors] = useState<Prosecutor[]>([]);
  const [polices, setPolices] = useState<Police[]>([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [formState, setFormState] = useState<Investigation>(
    investigation ?? defaultInvestigation,
  );

  useEffect(() => {
    if (
      investigation &&
      incidents &&
      crimeSubCategory &&
      prosecutors &&
      polices
    ) {
      setFormState(investigation);
    }
  }, [investigation, incidents, crimeSubCategory, prosecutors, polices]);

  useEffect(() => {
    if (file) {
      setFormState((prevState) => ({
        ...prevState,
        CR_number: file?.crime_reference_number || "",
      }));
    }
  }, [file]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchCrimeReferences().then(setIncidents),
      fetchCrimeSubCategory().then(setCrimeSubCategory),
      fetchProsecutor().then(setProsecutors),
      fetchPolice().then(setPolices),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail || errorHandler(error),
          "error",
        );
        setLoading(false);
      });
  }, []);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.CR_number) return "CR Number is Required.";
    // else if (!formState.assigned_police) return "Police is Required.";
    // else if (!formState.assigned_team) return "Assigned Team is Required.";
    // else if (!formState.description) return "Description is Required.";

    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setSubmitLoading(true);
    const submitAction =
      action === "Edit" ? editInvestigation : addInvestigation;
    submitAction({
      ...formState,
      crime_reference_id: incident?.uu_id as CrimeReference | null | undefined,
      Incident_Registration_number:
        incident?.Incident_Registration_number as string,
      investigation_status: "Completed",
    })
      .then(() => {
        if (action === "Edit" && file) {
          editReceivingInvestigationFile2({
            id: file?.id,
            status: InvestigationFileStatus.assigned_to_prosecutor,
          });
          navigate(`/investigation-files`);
        }

        showTooltip("Successfully Submitted!", "success");
        setFormState(defaultInvestigation);
        onClose(true);
      })
      .catch((error) => {
        showTooltip(
          error?.response?.data?.detail ||
            errorHandlerOnForm(error) ||
            errorHandler(error) ||
            "Something went wrong. Please try again.",
          "error",
        );
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <h2 className="mb-1 text-2xl font-semibold">{action} Investigation</h2>
        <p className="mb-6 text-xs font-light text-[#9D9D9D]">
          Lorem Ipsum is a publishing industries as a temporary filler.
        </p>

        {loading ? (
          <Loading />
        ) : (
          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* <div className="flex flex-col mt-4">
            <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
              Crime Reference Number
            </label>
            <select
              className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
              name="crime_reference_id"
              value={formState?.crime_reference_id?.toString()}
              onChange={handleChange}
            >
              <option value={""}>Select Crime Reference</option>
              {incidents.map((incident, index) => (
                <option key={index} value={incident.uu_id}>
                  {incident?.crime_reference_number}
                </option>
              ))}
            </select>
          </div> */}

            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400]">
                CR Number <span className="text-red-500">*</span>
              </label>
              <input
                required
                type="text"
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="CR_number"
                value={formState?.CR_number}
                onChange={handleChange}
                disabled={file ? true : false}
              />
            </div>
            <div className="grid grid-cols-2 gap-2 gap-x-4 ">
              {/* <div className="flex flex-col mt-4">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Crime Category
                </label>
                <select
                  className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                  name="crime_category_id"
                  value={formState?.crime_category_id?.toString()}
                  onChange={handleChange}
                >
                  <option value={""}>Select Crime Category</option>
                  {crimeSubCategory.map((category, index) => (
                    <option key={index} value={category.uu_id}>
                      {category?.crime_subcategory_name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Prosecutor
                </label>
                <input
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="assigned_prosecutor"
                  value={formState?.assigned_prosecutor?.toString()}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="flex flex-col mt-4">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Prosecutor
                </label>
                <select
                  className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                  name="assigned_prosecutor"
                  value={formState?.assigned_prosecutor?.toString()}
                  onChange={handleChange}
                >
                  <option value={""}>Select Prosecutor</option>
                  {prosecutors.map((prosecutor, index) => (
                    <option key={index} value={prosecutor.uu_id}>
                      {prosecutor?.full_name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Police
                </label>
                <input
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="assigned_police"
                  value={formState?.assigned_police?.toString()}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="flex flex-col mt-4">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Police
                </label>
                <select
                  className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                  name="assigned_police"
                  value={formState?.assigned_police?.toString()}
                  onChange={handleChange}
                >
                  <option value={""}>Select Police</option>
                  {polices.map((polices, index) => (
                    <option key={index} value={polices.uu_id}>
                      {polices?.full_name}
                    </option>
                  ))}
                </select>
              </div> */}
              {/* <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Investigation Status
                </label>
                <select
                  className="border border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
                  name="investigation_status"
                  value={formState?.investigation_status?.toString()}
                  onChange={handleChange}
                >
                  <option value={""}>Select Investigation Status</option>
                  {Object.entries(InvestigationStatus).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Assigned Team
                </label>
                <input
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="assigned_team"
                  value={formState?.assigned_team}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col mt-4 w-full">
                <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                  Start Date
                </label>
                <input
                  type="date"
                  className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                  name="start_date"
                  value={
                    formState?.start_date
                      ? new Date(formState.start_date)
                          .toISOString()
                          .split("T")[0]
                      : ""
                  }
                  max={
                    formState?.end_date
                      ? new Date(formState?.end_date)
                          .toISOString()
                          .split("T")[0]
                      : undefined
                  }
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Description
              </label>
              <textarea
                rows={4}
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="description"
                value={formState?.description}
                onChange={handleChange}
              />
            </div>

            <div className="flex flex-col mt-4 w-full">
              <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                Asset Reference
              </label>
              <input
                className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                name="asset_reference"
                value={formState?.asset_reference}
                onChange={handleChange}
              />
            </div>

            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className={`border border-[#212121] bg-[#212121] px-[76px] py-2 
                    text-white font-[Poppins] cursor-pointer font-[500] text-base rounded-md hover:bg-[#414040]
                            ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={loading}
              >
                {submitLoading ? (
                  <div className="flex items-center justify-center">
                    {LoadingIcon}
                    Loading...
                  </div>
                ) : action === "Add" ? (
                  "Submit Investigation"
                ) : (
                  "Edit Investigation"
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default InvestigationForm;
